<template>
  <div>
    <v-text-field
      label="Név"
      :error-messages="errors.name"
      v-model="reader.name"
      filled />
    <v-text-field
      label="Vonal"
      :error-messages="errors.controller_line"
      v-model="reader.controller_line"
      filled />
    <v-text-field
      label="Olvasó cím"
      :error-messages="errors.reader_address"
      v-model="reader.reader_address"
      type="number"
      filled />
    <v-text-field
      label="Kommunikációs cím"
      :error-messages="errors.reader_comm_address"
      v-model="reader.reader_comm_address"
      type="number"
      filled />
  </div>
</template>

<script>
import { useVModels } from '@vueuse/core';

export default {
  props: {
    reader: {
      type: Object,
      default: () => ({}),
    },

    number: {
      type: Number,
    },

    errors: {
      type: Object,
      default: () => ({}),
    },

    dense: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { reader, value } = useVModels(props, emit);
  },

  watch: {
    number: {
      immediate: true,
      handler(newValue, oldValue) {
        console.log(this.reader, newValue);
        if (this.reader.element_id === 0) {
          this.reader.name = `Olvasó #${String(newValue + 1).padStart(2, '0')}`;
          this.reader.reader_address = newValue + 1;
        }
      }
    },
  },
};
</script>